import { render, staticRenderFns } from "./kiosk-re-deal-detail.vue?vue&type=template&id=636da2ab&scoped=true&"
import script from "./kiosk-re-deal-detail.vue?vue&type=script&lang=js&"
export * from "./kiosk-re-deal-detail.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-re-deal-detail.vue?vue&type=style&index=0&id=636da2ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636da2ab",
  null
  
)

export default component.exports